import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { init } from "@amplitude/analytics-browser";
import { AMPLITUDE_CONFIG } from "./config/amplitude";
import { initSentry } from "./config/sentry";
import { GlobalErrorHandler } from "./utils/globalErrorHandler";

// Initialize Sentry first, before any other initialization
initSentry();

// Initialize global error handlers
GlobalErrorHandler.init();

// Initialize Amplitude early with API key only (userId will be set later in App)
init(AMPLITUDE_CONFIG.API_KEY, undefined, AMPLITUDE_CONFIG.OPTIONS);

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
